import { graphql } from '../graphql';

export const meQuery = graphql(`
  query Me {
    me {
      id
      firstName
      lastName
      name
      email
      mobileNumber
      avatarId
      onboardingSurveyCompleted
      onboardingTourCompleted
      twoFactorEnabled
      twoFactorType
      theme
      language
      isReferrer
      avatar {
        url
      }
      featurebaseUser {
        organization
        email
        name
        userId
        profilePicture
        featurebaseJwt
      }
      viewerSettings {
        pointCloudPointSizeType
        pointCloudPointSize
        orthoPointSize
        pointCloudLoadingDistance
        pointCloudMinNodePixelSize
        pointCloudPointBudget
        showLayerSource
        showLayerUnderType
        showImagePOIs
        showAllImagePOIs
        imagePOIMaxDistance
        showPointCloudBoundingBoxes
        showOrthoGrid
        googleStreetViewPoiColor
        backgroundColor
        actionPosition
        customBaseMaps {
          id
          name
          type
          url
          tileSize
          wmsVersion
          wmsLayers
          format
        }
      }
    }
  }
`);

export const userPasskeysQuery = graphql(`
  query UserPasskeys {
    userPasskeys {
      id
      name
      createdAt
      lastUsedAt
    }
  }
`);

export const renamePasskeyMutation = graphql(`
  mutation RenamePasskey($id: ID!, $name: String!) {
    renamePasskey(id: $id, name: $name)
  }
`);

export const deletePasskeyMutation = graphql(`
  mutation DeletePasskey($id: ID!) {
    deletePasskey(id: $id)
  }
`);

export const meUserSessionsQuery = graphql(`
  query MeUserSessions($userId: ID!) {
    userSessions(userId: $userId) {
      id
      createdAt
      expiresAt
      lastUsedAt
      revokedAt
      ipHash
      loginMethod
      country
      userAgent
      status
    }
  }
`);
